import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Notify } from 'notiflix/build/notiflix-notify-aio';
import axios from 'axios';
import { usePrice } from '../../../../hooks/usePrice';
import { ReactComponent as CrossIcon } from '../../../../icons/header/X.svg';
import { ReactComponent as ArrowRightIcon } from '../../../../icons/ArrowRight.svg';

import {
  CartModalPriceStyled,
  EmptyMessageStyled,
  ModalLinkStyled,
  ModalListStyled,
  ModalLowerStyled,
  ModalStyled,
  ModalTitleStyled,
} from './Modal.styled';

export const CartModal = ({ onClick }) => {
  const { countPrice } = usePrice();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const apiBaseUrl = `${process.env.REACT_APP_API_BASE_URL}/user/cart`;

  useEffect(() => {
    const loadCart = async () => {
      const token = sessionStorage.getItem('accessToken');
      if (!token) {
        Notify.info('Пожалуйста, авторизуйтесь');
        return;
      }

      setLoading(true);
      try {
        const { data } = await axios.get(`${apiBaseUrl}/by-session/get`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setItems(
            Array.isArray(data)
                ? data.map(i => ({
                  ...i,
                  quantity: i.totalQuantity ?? i.quantity ?? 1,
                }))
                : []
        );
      } catch (err) {
        // Notify.failure('Не удалось загрузить корзину');
      } finally {
        setLoading(false);
      }
    };

    loadCart();
    const onCartUpdated = () => {
           loadCart();
         };
       window.addEventListener("cartUpdated", onCartUpdated);

       return () => {
           window.removeEventListener("cartUpdated", onCartUpdated);
         };
  }, []);

  const handleRemoveItem = async productId => {
    const token = sessionStorage.getItem('accessToken');
    if (!token) {
      Notify.info('Пожалуйста, авторизуйтесь');
      return;
    }

    setLoading(true);
    try {
      await axios.delete(`${apiBaseUrl}/cart-item/${productId}/delete`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setItems(prev => prev.filter(i => i.id !== productId));
      Notify.success('Товар удалён из корзины');
    } catch {
      Notify.failure('Ошибка удаления из корзины');
    } finally {
      setLoading(false);
    }
  };

  const totalCount = items.reduce((sum, i) => sum + i.quantity, 0);
  const grandTotal = items.reduce((sum, i) => sum + i.price * i.quantity, 0);

  const getImageUrl = fileName =>
      fileName
          ? `${process.env.REACT_APP_API_BASE_URL}/public/images/${encodeURIComponent(
              fileName
          )}`
          : '/placeholder.png';

  return (
      <ModalStyled name="cart">
        <ModalTitleStyled>
          Корзина {totalCount > 0 && <span>({totalCount.toString().padStart(2, '0')})</span>}
        </ModalTitleStyled>

        {loading && <p>Загрузка...</p>}

        {!loading && items.length > 0 && (
            <ModalListStyled>
              {items.map(item => (

                  <li key={item.id}>

                    <img
                        src={getImageUrl(item.imageUrls?.[0] || '')}
                        alt={item.name}
                        width={80}
                        height={80}
                        loading="lazy"
                    />
                    <div>
                      <Link
                          to={`/shop/${item.name
                              .toLowerCase()
                              .replaceAll(' ', '-')}`}
                          onClick={onClick}
                      >
                        {item.name}
                      </Link>
                      <CartModalPriceStyled>
                        {item.quantity} × <span>{countPrice(item.price)}</span>
                      </CartModalPriceStyled>
                    </div>
                    <button
                        type="button"
                        onClick={() => handleRemoveItem(item.id)}
                        disabled={loading}
                        style={{ background: 'none', border: 'none', cursor: 'pointer' }}
                    >
                      <CrossIcon />
                    </button>
                  </li>
              ))}
            </ModalListStyled>
        )}

        {!loading && items.length === 0 && (
            <EmptyMessageStyled>Ваша корзина пуста!</EmptyMessageStyled>
        )}

        <ModalLowerStyled>
          {items.length > 0 && (
              <>
                <p>Sub-Total:</p>
                <span>{countPrice(grandTotal)}</span>
              </>
          )}
          <ModalLinkStyled to="/shopping-cart" onClick={onClick}>
            Посмотреть корзину
            <ArrowRightIcon />
          </ModalLinkStyled>
        </ModalLowerStyled>
      </ModalStyled>
  );
};
